import { Swiper } from 'swiper/bundle'

const mainBanner = new Swiper('.main-banner', {
	spaceBetween: 24,
	loop: true,
	slidesPerView: 1,
	loop: true,
	speed: 3600,
	autoplay: {
		delay: 1200,
		pauseOnMouseEnter: true
	}
})
